import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";

var img1 = require("./../../images/background/bg-5.png");
var img2 = require("./../../images/background/line.png");

// --- SERVICE DATA WITH POINTS ---
const servicePoints = {
  ecommerce: [
    {
      icon: "solar:cart-5-bold",
      text: "Fast delivery of essential supplies\nDelivered safely and without delays.",
    },
    {
      icon: "solar:delivery-bold",
      text: "On-time doorstep delivery\nReliable service for all your needs.",
    },
    {
      icon: "solar:box-bold",
      text: "Quality-checked products always\nEnsuring trust in every order.",
    },
    {
      icon: "solar:route-bold",
      text: "Live tracking with quick support\nStay updated from dispatch to delivery.",
    },
  ],

  labour: [
    {
      icon: "solar:verified-check-linear",
      text: "Skilled and verified labour support\nTrusted professionals for every task.",
    },
    {
      icon: "solar:clock-circle-bold",
      text: "On-demand labour availability\nConvenient booking whenever needed.",
    },
    {
      icon: "solar:star-bold",
      text: "Transparent pricing and ratings\nKnow the service quality beforehand.",
    },
    {
      icon: "solar:shield-warning-linear",
      text: "Experts for repair and maintenance\nQuick and efficient workmanship.",
    },
  ],

  apartments: [
    {
      icon: "solar:water-bold",
      text: "Professional plumbing services\nQuick and reliable solutions for leaks, fittings, and repairs.",
    },
    {
      icon: "solar:bolt-bold",
      text: "Certified electrical services\nSafe installation, wiring, and electrical maintenance.",
    },
    {
      icon: "solar:shield-star-line-duotone",
      text: "General apartment maintenance\nComprehensive repair and upkeep services.",
    },
    {
      icon: "solar:verified-check-bold",
      text: "Trusted service quality\nEnsuring reliable work with professional standards.",
    },
  ],
};

// --- Helper Hook to Read Query ---
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function OurServices3() {
  const query = useQuery();
  const type = query.get("id"); // ecommerce | labour | apartments

  // fallback if wrong or empty query
  const selectedPoints = servicePoints[type] || servicePoints.ecommerce;

  return (
    <>
      <div
        className="section-full p-t80 p-b50 bg-white mobile-page-padding"
        style={{ backgroundImage: "url(" + img1 + ")" }}
      >
        <div className="container">
          {/* TITLE */}
          <div className="section-head">
            <div className="mt-separator-outer separator-center">
              <div className="mt-separator">
                <h2 className="text-uppercase sep-line-one ">
                  <span className="font-weight-300 text-primary">Our</span>{" "}
                  Service Points
                </h2>
              </div>
            </div>
          </div>

          {/* CONTENT */}
          <div className="section-content">
            <div className="row">
              {selectedPoints.map((point, index) => (
                <div key={index} className="col-md-4 col-sm-6">
                  <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                    <div
                      className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary scale-in-center bg-moving"
                      style={{ backgroundImage: "url(" + img2 + ")" }}
                    >
                      <span className="icon-cell text-secondry">
                        <Icon icon={point.icon} width="32" height="32" />
                      </span>
                    </div>

                    <div className="icon-content">
                      <p className="font-weight-600">{point.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Back Button */}
            <div className="text-center m-t20">
              <NavLink to="/contact" className="site-button btn-effect">
                Get In Touch
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OurServices3;
